<template>
  <div
    class="bottom-overlay__wrapper h-20 overflow-hidden flex"
    :class="{ active }"
  >
    <div
      class="p-4 bg-white dark:bg-black border-t border-neutral-200 dark:border-neutral-600 bottom-overlay__inner mt-auto w-full"
    >
      <NamiSliderNew
        class="!h-8"
        :model-value="progress * 100"
        @update:modelValue="(v) => (progress = v / 100)"
        :min="0"
        :max="100"
        :loading
        noBg
        hide-number
        continuous
        @dragStart="emit('dragStart')"
        @dragEnd="emit('dragEnd')"
      >
        <template #label-prepend="{ modelValue }">
          <div class="min-w-[1rem] text-center">
            {{ modelValue.toFixed(0) }}%
          </div>
        </template>
        <template #label-tooltip="{ modelValue }">
          <div class="min-w-[1rem] text-center">
            {{ modelValue.toFixed(2) }}%
          </div>
        </template>
        <template #label-postpend="{ max }">
          <div class="min-w-[1rem] text-center">{{ max }}%</div>
        </template>
      </NamiSliderNew>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  active?: boolean;
  loading?: boolean;
}

interface Events {
  (e: "dragStart"): void;
  (e: "dragEnd"): void;
}

const {} = defineProps<Props>();
const emit = defineEmits<Events>();
const progress = defineModel<number>("progress", { required: true });
</script>

<style scoped lang="postcss">
.bottom-overlay__wrapper {
  & > .bottom-overlay__inner {
    transform: translateY(100%);
    transition: transform 150ms ease-in-out;
    @apply box-border h-16;
  }

  &:hover > .bottom-overlay__inner {
    @apply canhover:transform-none;
  }

  &.active > .bottom-overlay__inner {
    transform: none;
  }
}
</style>
